var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2.5605L21.4395 1.5L1.5 21.4395L2.5605 22.5L4.0605 21H19.5C19.8976 20.9994 20.2788 20.8412 20.56 20.56C20.8412 20.2788 20.9994 19.8976 21 19.5V4.0605L22.5 2.5605ZM19.5 19.5H5.5605L11.4052 13.6553L13.1895 15.4395C13.4708 15.7207 13.8523 15.8787 14.25 15.8787C14.6477 15.8787 15.0292 15.7207 15.3105 15.4395L16.5 14.25L19.5 17.2477V19.5ZM19.5 15.126L17.5605 13.1865C17.2792 12.9053 16.8977 12.7473 16.5 12.7473C16.1023 12.7473 15.7208 12.9053 15.4395 13.1865L14.25 14.376L12.4672 12.5933L19.5 5.5605V15.126ZM4.5 16.5V14.25L8.25 10.5023L9.27975 11.5328L10.3417 10.4708L9.3105 9.4395C9.02921 9.15829 8.64775 9.00032 8.25 9.00032C7.85225 9.00032 7.47079 9.15829 7.1895 9.4395L4.5 12.129V4.5H16.5V3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V16.5H4.5Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonNoImage);
export default __webpack_public_path__ + "static/media/carbon_no-image.17ef2dd4afbb70b618abd42dd38ca1a0.svg";
export { ForwardRef as ReactComponent };